import DesignEditorAuxiliaryControlBar from './DesignEditorAuxiliaryControlBar';

export default DesignEditorAuxiliaryControlBar;
